var Utils = require('./Utils');

var Class = function(){};


Class.extend = function(props){

    // extended class with the new prototype
    var parent;
    var proto;
    var i;
    var NewClass = function(){

        var i;
        var that = this;
        if('___hooks' in proto){
            for(i in proto.___hooks){
                if(!(i in proto)) continue;
                proto.___hooks[i].original = proto[i];
                proto[i] = (function(i){
                    return function(){
                        var ii;
                        var args_obj = {
                            "args":arguments,
                            "result":undefined
                        };
                        var rtrn;
                        for(ii in proto.___hooks[i].before){
                            args_obj['result'] = proto.___hooks[i].before[ii].call(that, args_obj);
                        }

                        args_obj['result'] = proto.___hooks[i].original.apply(that, arguments);
                        rtrn = args_obj['result'];

                        for(ii in proto.___hooks[i].after){
                            args_obj['result'] = proto.___hooks[i].after[ii].call(that, args_obj);
                            if(proto.___hooks[i].after[ii].override){
                                rtrn = args_obj['result'];
                            }
                        }

                        return rtrn;
                    }
                })(i);
            }
        }

        this.setOptions = function(options){
            Utils.setOptions(this, options);
        };

        // call the constructor
        if(this.initialize){
            this.initialize.apply(this, arguments);
        }
    };

    // instantiate class without calling constructor
    var F = function(){};
    F.prototype = this.prototype;

    proto = new F();
    proto.constructor = NewClass;

    NewClass.prototype = proto;

    //inherit parent's statics
    for(i in this){
        if(this.hasOwnProperty(i) && i !== 'prototype'){
            NewClass[i] = this[i];
        }
    }

    // mix static properties into the class
    if(props.statics){
        Utils.extend(NewClass, props.statics);
        delete props.statics;
    }

    // mix includes into the prototype
    if(props.includes){
        Utils.extend.apply(null, [proto].concat(props.includes));
        delete props.includes;
    }


    // merge options
    if(props.options && proto.options){
        props.options = Utils.extend({}, proto.options, props.options);
    }

    // mix given properties into the prototype
    Utils.extend(proto, props);

    parent = this;

    NewClass.__super__ = parent.prototype;


    return NewClass;
};

// method for adding properties to prototype
Class.include = function(props){
    Utils.extend(this.prototype, props);
};

Class._hook = function(before_after, methodName, func, override){
    var that = this;
    before_after || (before_after = 'before');
    override     || (override = false);
    if(!(methodName in that.prototype))throw Error('No method found');

    if(!('___hooks' in that.prototype)){
        that.prototype['___hooks'] = {};
    }

    if(!(methodName in that.prototype['___hooks'])){
        that.prototype['___hooks'][methodName] = {
            'before': [],
            'after': []
        };
    }

    func.override = override;

    that.prototype['___hooks'][methodName][before_after].push(func);

    return that;
};

// merge new default options to the Class
Class.mergeOptions = function(options){
    Utils.extend(this.prototype.options, options);
};

module.exports = Class;


//////////////////
// WEBPACK FOOTER
// ./src/~/Class.js
// module id = 4
// module chunks = 0